import { Component, Input, OnInit } from '@angular/core';
import * as moment from "moment";

@Component({
  selector: 'preview-list',
  templateUrl: './preview-list.component.html',
  styleUrls: ['./preview-list.component.scss']
})
export class PreviewListComponent implements OnInit {

  previewItems: any;
  selectedPreviewItems: any[];

  constructor() { }

  ngOnInit(): void {
    this.buildPreviewData();
  }

  buildPreviewData() {
    let lastValue = moment().utc();
    this.previewItems = [
      {uuid: 0, identifier: '003010A', description: 'Sensor de temperatura', status: 'online', lastValue: lastValue.subtract(Math.random(), 'hours').valueOf()},
      {uuid: 1, identifier: '003010B', description: 'Sensor de temperatura', status: 'online', lastValue: lastValue.subtract(Math.random(), 'hours').valueOf()},
      {uuid: 3, identifier: '003020A', description: 'Sensor de temperatura', status: 'offline', lastValue: lastValue.subtract(Math.random(), 'hours').valueOf()},
      {uuid: 2, identifier: '008032T', description: 'Sensor de CO2', status: 'online', lastValue: lastValue.subtract(Math.random(), 'hours').valueOf()},
      {uuid: 4, identifier: '008035T', description: 'Sensor de CO2', status: 'offline', lastValue: lastValue.subtract(Math.random(), 'hours').valueOf()}
    ];
    this.selectedPreviewItems = [this.previewItems[0], this.previewItems[3]];
  }

}
